import { DEV } from 'esm-env';
import { register_style } from '../dev/css.js';
import { effect } from '../reactivity/effects.js';
import { create_element } from './operations.js';

/**
 *
 *
 */
export function append_styles(anchor, css) {
	/*                                                                                                        */
	effect(() => {
		var root = anchor.getRootNode();

		var target = /*                     */ (root).host
			? /*                     */ (root)
			: /*                   */ (root).head ?? /*                   */ (root.ownerDocument).head;

		/*                                                                                                             */
		/*                                                                                                            */
		if (!target.querySelector('#' + css.hash)) {
			const style = create_element('style');
			style.id = css.hash;
			style.textContent = css.code;

			target.appendChild(style);

			if (DEV) {
				register_style(css.hash, style);
			}
		}
	});
}
